<template>
  <v-checkbox
    :input-value="checked"
    label="Show hidden providers"
    @change="onChange"
  ></v-checkbox>
</template>

<script>
export default {
  name: 'HiddenProviderToggle',
  props: ['checked'],
  methods: {
    onChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>
